import { UI_DEFAULTS } from '../locale/labels';
const DEFAULT_PRODUCT_NAME = UI_DEFAULTS.productName;
const DEFAULT_PRODUCT_TAG = UI_DEFAULTS.productTag;

function resolveObject(value) {
  return (
    value
    && typeof value === 'object'
    && !Array.isArray(value)
  ) ? value : {};
}

const pickFirstString = (values = []) => values.map((value) => String(value || '').trim()).find(Boolean) || '';

const withLogoDefaults = (labels, logoUrl, logoAlt) => {
  const resolved = { ...labels };
  const fields = [
    ['empty_state_logo_url', logoUrl], ['product_logo_url', logoUrl], ['sidebar_logo_url', logoUrl],
    ['empty_state_logo_alt', logoAlt], ['product_logo_alt', logoAlt], ['sidebar_logo_alt', logoAlt],
  ];
  fields.filter(([, value]) => Boolean(value)).forEach(([key, value]) => {
    resolved[key] = resolved[key] || value;
  });
  return resolved;
};

export function resolveChatBranding({
  defaultUILabels = {},
  instanceProfile = null,
  fallbackProductName = DEFAULT_PRODUCT_NAME,
  fallbackProductTag = DEFAULT_PRODUCT_TAG,
} = {}) {
  const profile = resolveObject(instanceProfile);
  const profileLabels = resolveObject(profile.ui_labels);
  const mergedLabels = {
    ...resolveObject(defaultUILabels),
    ...profileLabels,
  };
  const logoUrl = pickFirstString([
    profileLabels.logo_url,
    profile.logo_url,
  ]);
  const logoAlt = pickFirstString([
    profileLabels.logo_alt,
    profile.logo_text,
    profile.product_name,
  ]);

  return {
    resolvedUILabels: withLogoDefaults(mergedLabels, logoUrl, logoAlt),
    resolvedProductName: pickFirstString([profile.product_name, fallbackProductName]),
    resolvedProductTag: pickFirstString([profile.brand_tag, fallbackProductTag]),
  };
}
